import type {
  GuestDeskPackage,
  GuestDeskPackageListResponse,
} from '@mds/shared/types/guest-booking';

import { api } from '@/lib/api';

/** The public package endpoint — see `backend/docs/guest-bookings.md`. */

/**
 * Every desk package currently on sale, in rate-card order. A space's own
 * packages come inline on its detail instead (`GET /api/spaces/:slug`).
 */
export const listPackages = (): Promise<GuestDeskPackage[]> =>
  api.get<GuestDeskPackageListResponse>('packages').then((r) => r.data);
